import app from './modules/app';
import dic from './modules/dic';
import errorLog from "./modules/errorLog";
import getters from './getters';
import permission from './modules/permission';
import user from './modules/user';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        app,
        user,
        dic,
        permission,
        errorLog
    },
    getters
});

export default store;
